import React, { useState, useEffect } from "react";
import { List } from "antd";
import "styles/pages/Properties/PropertyForm.scss";
import { Icon } from "@iconify/react";
import { UserOutlined } from "@ant-design/icons";
import {
  LandlordListProps,
  LandlordOption,
} from "js/components/Landlords/types";

const LandlordList: React.FC<LandlordListProps> = ({
  propertiesOptions,
  selectedLandlord,
  onSelect,
  isSearching,
  filteredLandlord,
  setFilteredLandlord,
  listRef,
  scrollToTop,
}) => {
  const [selectedValue, setSelectedValue] = useState("");

  const moveItemToTop = (list: any[], valueToMove: string) => {
    const index = list.findIndex((item) => item.value === valueToMove);
    if (index === -1) return list;

    const item = list[index];
    const sortedArray = [...list];
    sortedArray.splice(index, 1);
    sortedArray.unshift(item);

    return sortedArray;
  };

  useEffect(() => {
    if (isSearching) {
      setFilteredLandlord((prev: LandlordOption[]) =>
        moveItemToTop(prev, selectedLandlord?.id),
      );
    } else {
      setFilteredLandlord(
        moveItemToTop(propertiesOptions, selectedLandlord?.id),
      );
    }
  }, [selectedLandlord, isSearching, propertiesOptions]);

  useEffect(() => {
    if (Object.keys(selectedLandlord).length) {
      setSelectedValue(selectedLandlord.id);
    } else {
      setSelectedValue("");
    }
  }, [selectedLandlord]);

  return (
    <div ref={listRef} id="scrollableDiv" className="landlord-list-container">
      <List
        size="small"
        dataSource={
          isSearching || selectedValue ? filteredLandlord : propertiesOptions
        }
        renderItem={(item) => {
          const isSelected = item.value === selectedValue;
          return (
            <List.Item
              key={item.value}
              className="landlord-list-item"
              style={{ backgroundColor: isSelected ? "#e6f7ff" : null }}
              onClick={() => {
                if (item.value !== selectedLandlord.id) {
                  onSelect(item.fields);
                  scrollToTop();
                }
              }}
            >
              <List.Item.Meta
                title={<p>{item.fields?.legal_entity_name || item.label}</p>}
              />
              <div>
                {item.fields.legal_entity_name ? (
                  <Icon icon="octicon:organization-24" />
                ) : (
                  <UserOutlined />
                )}
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default LandlordList;
